riot.tag2('bbc-notifications-bell', '<a name="notificationLink" id="notification-link" class="js-notification-link animated three notifications-shown {swing: opts.alert, notifications-black-bell: this.enabled, notifications-grey-bell: !this.enabled}" href="#"> <span class="hidden-span" style="height: 1px; width: 1px; position: absolute; overflow: hidden; top: -10px;">Notifications</span> <div class="notification-link--triangle"></div> <div class="notification-link--triangle"></div> <span id="not-num" class="{\'new-notifications\': opts.alert}"></span> <span aria-live="polite" class="notification-link__live notification-link__live--js">{opts.alert ? this.getAlertText() : \'\'}</span> </a>', '', '', function(opts) {
var _this = this;

if (opts.state === 'signed-in' || opts.state === 'on-boarding') {
    this.enabled = true;
} else {
    this.enabled = false;
}

this.getAlertText = function () {
    var drawerState = _this.parent.opts.mainApp.getDrawerState();
    return drawerState === 'hidden' ? 'New Notification. To view open the "Notification Panel" link.' : 'New Notification available.';
};
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-bell.tag
 ** module id = 12
 ** module chunks = 0
 **/